<section class="flex flex-col items-center gap-12">
  <app-section-header
    [icon]="'@tui.book-open'"
    [subtitle]="'Blog'"
    [title]="'Latest from our blog'"
  >
  </app-section-header>
  <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
    @for (post of posts(); track post.title) {
      <article
        class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-2 flex items-center gap-2">
          <tui-chip appearance="info" size="s">{{ post.tag }}</tui-chip>
          <span class="text-sm text-text-secondary">{{ post.date }}</span>
        </div>
        <h3 class="text-xl font-bold md:text-2xl">{{ post.title }}</h3>
        <p class="text-pretty text-lg">
          {{ post.description }}
        </p>
        <div class="mt-auto flex items-center gap-3">
          <img
            [src]="post.authorImageUrl"
            [alt]="post.authorName"
            class="h-10 w-10 rounded-full object-cover"
          />
          <div class="flex flex-col">
            <span class="font-medium">{{ post.authorName }}</span>
            <span class="text-sm text-text-secondary">{{
              post.authorDescription
            }}</span>
          </div>
        </div>
        <a
          appearance="flat"
          iconEnd="@tui.arrow-right"
          size="l"
          tuiButton
          type="button"
          [href]="post.link"
          target="_blank"
        >
          Read more
        </a>
      </article>
    }
  </div>
</section>
